export enum SessionKeys {
  navigateback = 'app_navigateback',
  sessionId = 'app_appsessionid',
  viewMode = 'app_viewmode',
  selectedFences = 'app_selectedFences',
  selectedClasses = 'app_selectedClasses',
  selectedRaceId = 'app_selectedRace',
  tokens = 'app_tokens',
  user = 'app_user',
  histList = 'app_histList',
}
